import type { CheckboxIndicatorState } from "@design-system/Checkbox/CheckboxIndicator";
import type { SelectedPreviewEntity } from "./applyCoaTemplatePreviewEntries";

export function getClientCheckboxState({
    clientEntries,
    selectedEntityIds,
}: {
    clientEntries: SelectedPreviewEntity[];
    selectedEntityIds: ReadonlySet<number>;
}): CheckboxIndicatorState {
    const selectedCount = clientEntries.filter((entry) =>
        selectedEntityIds.has(entry.entityId),
    ).length;
    if (selectedCount === 0) {
        return "unchecked";
    }
    if (selectedCount === clientEntries.length) {
        return "checked";
    }
    return "indeterminate";
}

// Summarises why a client's selection is unavailable: one reason shared by every
// blocked child is stated verbatim, mixed reasons collapse to a count so the
// label stays readable.
export function getClientSelectionDisabledReason({
    clientEntries,
    disabledReasonsByEntityId,
}: {
    clientEntries: SelectedPreviewEntity[];
    disabledReasonsByEntityId: ReadonlyMap<number, string>;
}): string | undefined {
    const reasons = clientEntries.flatMap((entry) => {
        const reason = disabledReasonsByEntityId.get(entry.entityId);
        return reason ? [reason] : [];
    });
    const [firstReason] = reasons;
    if (!firstReason) {
        return undefined;
    }
    if (reasons.every((reason) => reason === firstReason)) {
        return firstReason;
    }
    return `${reasons.length} of ${clientEntries.length} entities can’t be selected`;
}
